/*پارک و باغ*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={90.937}
      height={98.013}
      viewBox="0 0 90.937 98.013"
      {...props}
    >
      <g data-name="Group 380">
        <path
          data-name="Path 7851"
          d="M10.047 94.854V52.125a1.335 1.335 0 00-1.335-1.335H2.771a1.335 1.335 0 00-1.335 1.335v42.729a1.335 1.335 0 001.335 1.335h5.942a1.334 1.334 0 001.334-1.335z"
          fill="#5a5a5a"
        />
        <path
          data-name="Path 7852"
          d="M55.04 45.186h10.224v38.421H55.04z"
          fill="#c86d36"
        />
        <path
          data-name="Path 7853"
          d="M58.779 45.186h6.485v38.421h-6.485z"
          fill="#ac5e2e"
        />
        <path
          data-name="Path 7854"
          d="M79.262 21.701c-.083-11.207-8.606-20.265-19.109-20.265s-19.026 9.058-19.109 20.265c-5.937 1.725-10.24 6.82-10.24 12.838 0 8.839 9.149 15.307 18.492 13a12.581 12.581 0 0021.713 0c9.352 2.307 18.492-4.171 18.492-13 .001-6.018-4.303-11.113-10.239-12.838z"
          fill="#09a76d"
        />
        <g data-name="Group 378" fill="#cecece">
          <path
            data-name="Path 7855"
            d="M27.032 84.204V70.238a1.335 1.335 0 011.335-1.335h2.494a1.335 1.335 0 011.335 1.335v13.967a1.335 1.335 0 01-1.335 1.335h-2.494a1.335 1.335 0 01-1.335-1.336z"
          />
          <path
            data-name="Path 7856"
            d="M65.324 84.204V70.238a1.335 1.335 0 011.335-1.335h2.494a1.335 1.335 0 011.335 1.335v13.967a1.335 1.335 0 01-1.335 1.335h-2.494a1.335 1.335 0 01-1.335-1.336z"
          />
          <path
            data-name="Path 7857"
            d="M27.032 95.244v-8.37a1.335 1.335 0 011.335-1.335h2.494a1.335 1.335 0 011.335 1.335v8.37a1.335 1.335 0 01-1.335 1.335h-2.494a1.335 1.335 0 01-1.335-1.335z"
          />
          <path
            data-name="Path 7858"
            d="M65.324 95.244v-8.37a1.335 1.335 0 011.335-1.335h2.494a1.335 1.335 0 011.335 1.335v8.37a1.335 1.335 0 01-1.335 1.335h-2.494a1.335 1.335 0 01-1.335-1.335z"
          />
        </g>
        <path
          data-name="Path 7859"
          d="M18.679 9.327h12.922v3.644a2.478 2.478 0 01-2.478 2.478h-7.965a2.478 2.478 0 01-2.478-2.478z"
          fill="#fece85"
        />
        <path
          data-name="Path 7860"
          d="M18.679 9.327h12.922v-3.6a2.86 2.86 0 00-2.86-2.86h-7.2a2.86 2.86 0 00-2.86 2.86z"
          fill="#838383"
        />
        <path
          data-name="Path 7861"
          d="M18.679 7.897h12.922v-3.6a2.86 2.86 0 00-2.86-2.86h-7.2a2.86 2.86 0 00-2.86 2.86z"
          fill="#838383"
        />
        <g data-name="Group 379">
          <path
            data-name="Path 7862"
            d="M79.262 21.701c-.083-11.207-8.606-20.265-19.109-20.265a18.032 18.032 0 00-3.334.31c8.916 1.677 15.7 9.961 15.776 19.955 5.937 1.725 10.24 6.82 10.24 12.838 0 6.385-4.845 11.728-11.343 13.113 9.217 1.972 18.011-4.456 18.011-13.113-.001-6.018-4.305-11.113-10.241-12.838z"
            fill="#02905d"
          />
        </g>
        <path
          data-name="Path 7863"
          d="M69.154 68.903H66.66a1.335 1.335 0 00-1.335 1.335v9.913h5.164v-9.913a1.334 1.334 0 00-1.335-1.335z"
          fill="#bfbfbf"
        />
        <path
          data-name="Path 7864"
          d="M30.861 68.903h-2.494a1.335 1.335 0 00-1.335 1.335v9.913h5.163v-9.913a1.334 1.334 0 00-1.334-1.335z"
          fill="#bfbfbf"
        />
        <path
          data-name="Path 7865"
          d="M65.326 92.32h5.164c0-5.965.045-5.634-.12-6h-4.924c-.166.367-.12.065-.12 6z"
          fill="#bfbfbf"
        />
        <path
          data-name="Path 7866"
          d="M27.033 86.873v5.447h5.164v-5.447a1.326 1.326 0 00-.12-.55h-4.924a1.327 1.327 0 00-.12.55z"
          fill="#bfbfbf"
        />
        <path
          data-name="Path 7867"
          d="M74.868 75.032V61.475a1.335 1.335 0 00-1.335-1.335H23.448a1.335 1.335 0 00-1.335 1.335v13.558a1.335 1.335 0 001.335 1.335h50.085a1.335 1.335 0 001.335-1.336z"
          fill="#fedba6"
        />
        <path
          data-name="Path 7868"
          d="M77.432 87.203v-3.332a1.335 1.335 0 00-1.335-1.335H20.883a1.335 1.335 0 00-1.335 1.335v3.328a1.335 1.335 0 001.335 1.335h55.215a1.335 1.335 0 001.334-1.331z"
          fill="#fedba6"
        />
        <path
          data-name="Path 7869"
          d="M74.073 60.14h-6.485a1.335 1.335 0 011.335 1.335v13.557a1.335 1.335 0 01-1.335 1.335h6.485a1.335 1.335 0 001.335-1.335V61.475a1.335 1.335 0 00-1.335-1.335z"
          fill="#fece85"
        />
        <path
          data-name="Path 7870"
          d="M76.638 82.54h-6.485a1.335 1.335 0 011.335 1.335v3.328a1.335 1.335 0 01-1.335 1.335h6.485a1.335 1.335 0 001.335-1.335V83.87a1.335 1.335 0 00-1.335-1.33z"
          fill="#fece85"
        />
        <path
          data-name="Path 7871"
          d="M9.253 50.79H5.47a1.335 1.335 0 011.335 1.335v42.729a1.335 1.335 0 01-1.335 1.335h3.783a1.335 1.335 0 001.335-1.335v-42.73a1.334 1.334 0 00-1.335-1.334z"
          fill="#444"
        />
      </g>
      <g data-name="Group 381">
        <path
          data-name="Path 7872"
          d="M17.243 12.97a3.919 3.919 0 003.914 3.914h7.961a3.919 3.919 0 003.914-3.914V5.726a4.3 4.3 0 00-4.3-4.3H13.066a8.5 8.5 0 00-8.49 8.49v39.438H2.77A2.774 2.774 0 000 52.124v42.729a2.774 2.774 0 002.77 2.77h6.482a2.774 2.774 0 002.77-2.77V52.125a2.774 2.774 0 00-2.77-2.77H7.447V9.92a5.625 5.625 0 015.619-5.619h4.421a4.276 4.276 0 00-.244 1.424v7.245zM9.152 94.752h-6.28V52.226h6.28zM30.165 12.97a1.044 1.044 0 01-1.047 1.043h-7.961a1.044 1.044 0 01-1.039-1.043v-2.21h10.05v2.21zm-1.424-8.669a1.426 1.426 0 011.424 1.424V7.89H20.118V5.726a1.426 1.426 0 011.424-1.424z"
        />
        <path
          data-name="Path 7873"
          d="M71.718 49.161a17.4 17.4 0 003.108.28c8.883 0 16.11-6.685 16.11-14.9a14.906 14.906 0 00-10.271-13.892 22.847 22.847 0 00-2.918-10.076 1.437 1.437 0 10-2.5 1.418 20.027 20.027 0 012.574 9.723 1.436 1.436 0 001.035 1.368c5.505 1.6 9.2 6.205 9.2 11.459 0 6.633-5.939 12.03-13.239 12.03a14.517 14.517 0 01-3.474-.421 1.436 1.436 0 00-1.611.719 11.148 11.148 0 01-19.179 0 1.435 1.435 0 00-1.611-.719 14.517 14.517 0 01-3.474.421c-7.3 0-13.239-5.4-13.239-12.03 0-5.254 3.7-9.86 9.2-11.459a1.436 1.436 0 001.035-1.368c.078-10.389 8.006-18.84 17.674-18.84a16.963 16.963 0 0111.2 4.3 1.436 1.436 0 101.9-2.154A19.645 19.645 0 0045.63 6.381a22.379 22.379 0 00-6.008 14.266 14.906 14.906 0 00-10.27 13.891c0 8.217 7.227 14.9 16.11 14.9a17.4 17.4 0 003.108-.28 13.042 13.042 0 005.019 4.487V58.7H38.342a1.436 1.436 0 100 2.871h35.63v13.36H23.548V61.575h8.094a1.436 1.436 0 100-2.871h-8.2a2.774 2.774 0 00-2.77 2.77v13.558a2.774 2.774 0 002.77 2.77h2.15v3.3h-4.714a2.774 2.774 0 00-2.77 2.77V87.2a2.774 2.774 0 002.77 2.77h4.715v5.27a2.774 2.774 0 002.77 2.77h2.494a2.774 2.774 0 002.77-2.77v-5.27h30.257v5.27a2.774 2.774 0 002.77 2.77h2.494a2.774 2.774 0 002.77-2.77v-5.27h4.714a2.774 2.774 0 002.77-2.77v-3.326a2.774 2.774 0 00-2.77-2.77h-4.714V77.8h2.149a2.774 2.774 0 002.77-2.77V61.475a2.774 2.774 0 00-2.77-2.77h-7.373v-5.058a13.046 13.046 0 005.018-4.487zM63.829 77.8v3.3h-7.353v-3.3zm-30.2 3.3v-3.3h19.973v3.3zm-5.163-3.3h2.292v3.3h-2.29zm2.292 17.339h-2.29v-5.167h2.292zm38.292 0h-2.292v-5.167h2.292zm7.484-8.041H20.983v-3.123h55.553zm-7.484-6h-2.292V77.8h2.292zm-5.223-22.4h-7.353v-3.963a14.747 14.747 0 007.353 0V58.7z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
